import type { TaskResponse } from "./tasksApi";
import type { TaskFilters } from "./TaskSearch";

export function filterTasks(tasks: TaskResponse[], filters: TaskFilters): TaskResponse[] {
  return tasks
    .filter((task) => !filters.query || matchesQuery(task, filters.query.trim().toLowerCase()))
    .filter(({ assignedUser }) => !filters.assignedUserId || assignedUser === filters.assignedUserId);
}

function matchesQuery({ description, parent }: TaskResponse, query: string): boolean {
  const orderNumber = parent.type === "ORDER" ? String(parent.userFriendlyId) : "";
  return description.toLowerCase().includes(query) || orderNumber.includes(query);
}
